export default {
  SET_STOCK_LOG(state, res) {
    state.stockLogs = res.items
    state.totalDataRow = res.totalCount;
  },
}
